document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('csForm');
  const submitButton = document.getElementById('csSubmit');
  const thanks = document.getElementById('thanks');
  const requiredFields = document.querySelectorAll('.--required');
  const errorMessages = document.querySelectorAll('.customerSatisfaction__errorMsg');

  // 初期状態で thanks を非表示
  thanks.style.display = 'none';

  // エラーメッセージを非表示にする関数
  function clearErrors() {
    errorMessages.forEach(msg => {
      msg.style.display = 'none';
    });
  }

  // 個別エラー非表示
  function hideError(field) {
    const errorMsg = field.parentElement.querySelector('.customerSatisfaction__errorMsg');
    if (errorMsg) {
      errorMsg.style.display = 'none';
    }
  }

  // ライブバリデーション用イベント登録
  function setupLiveValidation() {
    requiredFields.forEach(field => {
      const input = field.querySelector('input');

      // ラジオボタン
      if (field.tagName === 'UL') {
        const radios = field.querySelectorAll('input[type="radio"]');
        radios.forEach(radio => {
          radio.addEventListener('change', () => hideError(field));
        });
      }

      // 通常input
      else if (input && input.type !== 'hidden') {
        input.addEventListener('input', () => hideError(field));
      }
    });
  }

  // フォームバリデーション
  function validateForm() {
    let isValid = true;
    clearErrors();

    requiredFields.forEach(field => {
      const input = field.querySelector('input');
      const errorMsg = field.parentElement.querySelector('.customerSatisfaction__errorMsg');

      // ラジオボタンのケース
      if (field.tagName === 'UL') {
        const radios = field.querySelectorAll('input[type="radio"]');
        const isChecked = Array.from(radios).some(radio => radio.checked);
        if (!isChecked && errorMsg) {
          errorMsg.style.display = 'inline-block';
          isValid = false;
        }
      }

      // 通常の input のケース（textareaは除外）
      else if (input && input.type !== 'hidden') {
        const value = input.value.trim();
        if (value === '') {
          if (errorMsg) errorMsg.style.display = 'inline-block';
          isValid = false;
        } else if (input.name.includes('entry.1806226261')) {
          // メール形式チェック
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(value)) {
            if (errorMsg) errorMsg.style.display = 'inline-block';
            isValid = false;
          }
        }
      }
    });

    return isValid;
  }

  // 送信ボタン押下時
  submitButton.addEventListener('click', function () {
    if (validateForm()) {
      form.style.display = 'none';
      thanks.style.display = 'block';
      form.submit();
    }
  });

  // ライブバリデーション起動
  setupLiveValidation();
});
